export type WindowWithDatalayer = {
  dataLayer: {
    push: (args: DatalayerProps) => void
  }
}

export type DatalayerProps = {
  category: string
  action: string
  label?: string
} & OptionalSearchParams &
  OptionalMenuParams &
  OptionalLanguageParams

export type OptionalSearchParams = {
  numberOfResults?: string
}

export type OptionalLanguageParams = {
  language?: string
}

export type OptionalMenuParams = {
  menuType?: 'main' | 'sub' | 'cta' | 'copyright' | 'contact'
}

const defaultParams = {
  event: `event.${sitename}`,
  label: window.location.pathname,
}

export const pushDatalayer = (props: DatalayerProps) => {
  const params = { ...defaultParams, ...props }
  console.groupCollapsed('pushDatalayer:', params.category)
  console.log(params)
  console.groupEnd()

  if (window.dataLayer) window.dataLayer.push(params)
}
